module.exports = __webpack_public_path__ + "img/hero-text-2.71e5f554.svg";